(function () {
  if (window.__wotSharedInit) return;
  window.__wotSharedInit = true;

  function animateCounters(scope) {
    var counters = (scope || document).querySelectorAll('[data-target]');
    counters.forEach(function (counter) {
      if (counter.dataset.animated) return;
      var target = parseInt(counter.dataset.target, 10);
      var suffix = counter.dataset.suffix || '';
      var duration = 2000;
      var start = performance.now();
      function update(now) {
        var elapsed = now - start;
        var progress = Math.min(elapsed / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        counter.textContent = Math.floor(eased * target).toLocaleString('en-IN') + suffix;
        if (progress < 1) requestAnimationFrame(update);
      }
      counter.dataset.animated = 'true';
      requestAnimationFrame(update);
    });
  }
  window.__wotAnimateCounters = animateCounters;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        if (entry.target.classList.contains('stats-grid')) {
          animateCounters(entry.target);
        }
      }
    });
  }, { threshold: 0.01, rootMargin: '0px 0px -30px 0px' });
  window.__wotObserver = observer;

  function init() {
    document.querySelectorAll('.wot-page .fade-in').forEach(function (el) { observer.observe(el); });
    document.querySelectorAll('.wot-page .stats-grid').forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
